import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, Row } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { AppDispatch, RootState } from "../../../../store/app";
import { useDispatch, useSelector } from "react-redux";
import { rules } from "./Rules";
import { doRegister, doRegisterInvitedUser, getRegisterDetails, getAccessCodeDetails, sendUserOtp } from "../../../../store/AuthSlice";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { assignErrorToInput } from "../../../../store/api";
import { Notification, mobilePattern, base64EncodeDecode, setResetInputAnimation } from "../../../../config/Global";
import PageNotFound from "../../../errors/PageNotFound";
import { getStatus } from "../../HomePage/utils/slice";
import loginlogo from "../../../../assets/images/login-logo.svg"
import loginbgMob from "../../../../assets/images/login-img-new-mobile.svg"
import { has } from "lodash";
import VerifyAccount from "../VerifyAccount/VerifyAccount";
import { WebConstant } from "../../webConstant/WebConstant";
/**
 * Renders the component for registration .
 *
 * @return {JSX.Element} The rendered component.
 */
const Register = () => {
	const dispatch: AppDispatch = useDispatch();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false)
	const [form] = Form.useForm();
	const { user_id, access_code_id }: any = useParams();
	const [decodedUserID, setDecodedUserID] = useState<any>(null);
	const [directLogin, setDirectLogin] = useState<number>(1);
	const [hasAccessCode, setHasAccessCode] = useState<boolean>(false);
	const [verificationData, setVerificationData] = useState<any>(null);

	const [isVerification, setIsVerification] = useState(false);


	useEffect(() => {
		if (hasAccessCode) {
			setResetInputAnimation(false);
			setResetInputAnimation()
		}
	}, [hasAccessCode]);

	const FaildRedirectToLogin = () => {
		Notification.error({
			message: "Link is not valid. Please contact the administrator.",
		});
		navigate("/login");
	}


	const setUSerOtp = (data: any) => {
		dispatch(sendUserOtp(data))
			.then((response: any) => {
				setVerificationData(data);
				setIsVerification(true);
				setLoading(false)
			})
			.catch((error: any) => {
				assignErrorToInput(form, error?.STATUS)
				setLoading(false)
			})
	}


	const handleSubmit = (data: any) => {
		// console.log(data);
		// return 0;
		setLoading(true);
		data.tearm_and_conditiom = data.tearm_and_conditiom[0]

		if (directLogin != 2) {

			dispatch(doRegister(data))
				.then(() => {

					const mydata = {
						username: data.email,
						password: data.password,
						remember: false,
					}
					setUSerOtp(mydata)
				})
				.catch((error: any) => {
					assignErrorToInput(form, error?.STATUS)
					setLoading(false)
				});
		}
		else {
			dispatch(doRegisterInvitedUser(decodedUserID, data))
				.then(() => {
					const mydata = {
						username: data.email,
						password: data.password,
						remember: false,
					}
					setUSerOtp(mydata)
				})
				.catch((error: any) => {
					assignErrorToInput(form, error?.STATUS)
					setLoading(false)
				});
		}
	};


	// const sendOtpto

	const validateForm = () => {
		form.validateFields({ dirty: true })
	};

	useEffect(() => {
		setLoading(true);
		dispatch(getStatus("homepage")).then((data: any) => {
			setDecodedUserID(null);
			setDirectLogin(1);
			if (user_id != undefined) {
				setDirectLogin(2);
				setDecodedUserID(user_id);
				getUserDetails(user_id);
				setHasAccessCode(true);
				setLoading(false);
				return 0;
			}
			else if (access_code_id != undefined) {

				const access = access_code_id;
				getAccessDetails(access);
				setHasAccessCode(true);
				setDirectLogin(3);
				setHasAccessCode(true);
				setLoading(false);
				return 0;
			}
			setLoading(false);


		}).catch((error: any) => error)

	}, [user_id, access_code_id])


	const getAccessDetails = (access_id: any) => {
		dispatch(getAccessCodeDetails(access_id))
			.then((data: any) => {
				if (data?.id != undefined) {
					form.setFieldsValue({ access_code: data.enc_code });
					setLoading(false)
				}
				else {
					form.setFieldsValue({ access_code: '' });
					setDirectLogin(1);
					setLoading(false);
					navigate("/register");
				}

			})
			.catch((error: any) => {
				form.setFieldsValue({ access_code: '' });
				setDirectLogin(1);
				setLoading(false);
				navigate("/register");
			});
	}

	const getUserDetails = (user_id: any) => {
		dispatch(getRegisterDetails(user_id))
			.then((data: any) => {
				if (data?.is_invite != 1) {
					setLoading(false)
					FaildRedirectToLogin();
				}
				form.setFieldsValue(data);
				form.setFieldsValue({ mobile_no: (data.mobile_no && data.mobile_no != null) ? mobilePattern(data.mobile_no) : null })

			})
			.catch((error: any) => {
				console.error(error);
				FaildRedirectToLogin();
			});
	}
	const logo = useSelector((state: RootState) => state.HOME.pageSettings?.banner?.banner_logo)

	return (
		<>
			<section className={`webLoginSection  ${isVerification ? 'webForgotPassword' : 'webRegisterSection'}`} >
				<div className="ant-row no-gutter">


					<div className="ant-col-xxl-12 ant-col-xl-12 ant-col-lg-12 ant-col-md-12">
						<div className="login-bg register-bg">
							<div className="login-bg-in"><img src={loginbgMob} alt="" /></div>
						</div>
					</div>

					<div className="ant-col-xxl-12 ant-col-xl-12 ant-col-lg-12 ant-col-md-12 form-col">
						{!isVerification ? <div className="webLoginBox">
							<div className="login-logo">
								<Link to={'/login'}>
									<img src={WebConstant?.IMAGE_URL + logo} alt="" />
								</Link>
							</div>

							<h2 className="subtitle">Join the Future of Energy</h2>
							<p>Sign up and start your clean energy journey today.</p>
							<FormBox form={form} onFinish={handleSubmit} onChange={validateForm}>
								<Row gutter={20}>
									<Col sm={12} xs={24} md={12} xxl={12}>
										<InputBox.Text
											name="name"
											label={<>First name <em>*</em></>}
											placeholder=''
											// className='ecn-input'
											className={'ecn-input ' + (directLogin == 1 ? '' : 'active')}
											rules={rules.name()}
										/>
									</Col>

									<Col sm={12} xs={24} md={12} xxl={12}>
										<InputBox.Text
											name="last_name"
											label={<>Last name <em>*</em></>}
											placeholder=''
											// className='ecn-input'
											className={'ecn-input ' + (directLogin == 1 ? '' : 'active')}
											rules={rules.last_name()}
										/>
									</Col>
								</Row>
								<Row gutter={20}>
									<Col sm={12} xs={24} md={12} xxl={12}>
										<InputBox.Text
											name="mobile_no"
											label={<>Phone number <em>*</em></>}
											placeholder=''
											// className='ecn-input'
											className={'ecn-input ' + (directLogin == 1 ? '' : 'active')}
											rules={rules.mobile()}
											onChange={(e: any) => {

												if (e.target.value.length > 0) {

													form.setFieldsValue({ mobile_no: mobilePattern(e.target.value) })

												}
											}}
										/>
									</Col>

									<Col sm={12} xs={24} md={12} xxl={12}>
										<InputBox.Text
											name="email"
											label={<>Email <em>*</em></>}
											placeholder=''
											// className='ecn-input'
											className={'ecn-input ' + (directLogin == 1 ? '' : 'active')}
											rules={rules.email()}
											onChange={(e) => form.setFieldValue('email', e.target.value.trim())}
										/>
									</Col>
								</Row>

								<Row>
									<Col sm={12} xs={24} md={12} xxl={12}>
										<InputBox.Password
											name="password"
											label={<>Password <em>*</em></>}
											placeholder=''
											className={'ecn-input ' + (directLogin == 1 ? '' : 'active')}
											rules={rules.password()}
										/>
									</Col>
									<Col sm={12} xs={24} md={12} xxl={12}>
										<InputBox.Password
											name="password_confirmation"
											label={<>Confirm password <em>*</em></>}
											placeholder=''
											className={'ecn-input ' + (directLogin == 1 ? '' : 'active')}
											rules={rules.password_confirmation()}
										/>
									</Col>
								</Row>
								{directLogin == 1 && <Row>
									<Col sm={24} xs={24} md={24} xxl={24}>
										<InputBox.Checkbox
											onChange={(item) => {
												setHasAccessCode(item.length > 0)
											}}
											options={{
												list: [
													{
														id: 1,
														name: "I have an access code",
													},
												],
											}}


										/>
									</Col>
								</Row>}
								<Row style={{ display: hasAccessCode ? 'flex' : 'none' }} >
									<Col sm={24} xs={24} md={24} xxl={24}>
										<InputBox.Text
											name={hasAccessCode ? "access_code" : null}
											label={<>Access Code <em>*</em></>}
											placeholder=''
											// className='ecn-input'
											className={'ecn-input ' + (directLogin == 1 ? '' : 'active')}
											rules={hasAccessCode ? rules.access_code() : null}
											disabled={directLogin != 1}
										/>
									</Col>
								</Row>
								{/* <Divider /> */}

								<Row>

									<Col sm={24} xs={24} md={24} xxl={24}>
										<div>


											<InputBox.Checkbox
												defaultValue={[1]}
												name="tearm_and_conditiom"
												rules={rules.tearmandconditiom()}
												extra={<Link to="/terms-of-use" target="_blank" className="tearmAndConditiomLink">
													Terms & Conditions
												</Link>}

												options={{
													list: [
														{
															id: 1,
															name: "By signing up you agree with our",
														},
													],
												}}


											/>

										</div>
									</Col>
								</Row>

								<div className="logInBtn">
									<Button
										className="log_in_button secondry_btn_log_page green-btn"
										htmlType="submit"
										loading={loading}
									>
										Sign up
									</Button>
								</div>
								{directLogin == 1 && <>
									<Divider>or</Divider>
									<div className="logInBtn">
										<Button
											className="log_in_button secondry_btn_log_page"
											onClick={() => navigate("/login")}
										>
											Sign in
										</Button>
									</div>
								</>}
							</FormBox>
						</div>
							:
							<VerifyAccount verificationData={verificationData} />
						}
					</div>

				</div>
			</section>
		</>
	)
};

export default Register;